import { useQuery, useSubscription } from "@apollo/react-hooks";
import { MY_TIME_GET_REQUEST } from "my-time/graphql/queries";
import { MY_TIME_REQUESTS_SUBSCRIPTION } from "my-time/graphql/subscriptions";

export const useMyTimeRequest = ({ _id }: { _id: string }) => {
  const { data, loading, error, refetch } = useQuery(MY_TIME_GET_REQUEST, {
    fetchPolicy: "cache-and-network",
    variables: {
      _id,
    },
  });

  useSubscription(MY_TIME_REQUESTS_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.getMyTimeRequest || {},
    loading: loading && !data,
    error,
    refetch
  };
};

export default useMyTimeRequest;
